// mui
import { Box } from '@mui/material';

// theme
import { theme } from '../../../theme';

// props
export interface HtmlProps {
	html: string;
}

export const Html = ({ html }: HtmlProps) => {
	// vars
	const markup = html;
	const sxImg = {
		borderRadius: 2,
		display: 'block',
		width: '100%',
	};

	return (
		<Box
			sx={{
				'& img': sxImg,
				'& p:last-of-type': {
					marginBottom: 0,
				},
				'& ul, & ol': {
					margin: theme.spacing(0, 0, 2, 0),
					'&:last-of-type': {
						marginBottom: 0,
					},
				},
				'& h1, & h2, & h3, & h4, & h5, & h6': {
					margin: theme.spacing(0, 0, 2, 0),
				},
			}}
			dangerouslySetInnerHTML={{ __html: markup }}
		/>
	);
};
